import { _, PageContext } from '@zto/zpage'

import { commonOptions } from '@/config'
import { getCommonOptionLabel } from '@/utils'

// 新增/编辑对话框
export const addEditDialog = (isEdit: Boolean) => {
  return {
    width: 500,
    itemSpan: 24,

    onShow: async ({ app, data }: PageContext) => {
      const payload = _.pick(
        data,
        'manufacturerCode',
        'manufacturerName',
        'supplyScopeCodes',
        'contact',
        'phone',
        'remark'
      )

      payload.supplyScopeCodes = payload.supplyScopeCodes || []

      return { payload }
    },

    beforeSubmit: async ({ app, data }: PageContext, model: any) => {
      const payload = _.deepClone(data)

      const supplyScopeCodes = data.supplyScopeCodes || []

      const supplyScopeList = supplyScopeCodes.map((it: any, index: number) => {
        const supplyScopeName = getCommonOptionLabel(commonOptions.tdlDeviceType, it)
        return {
          supplyScopeCode: supplyScopeCodes[index],
          supplyScopeName
        }
      })

      payload.supplyScopeList = supplyScopeList

      delete payload.supplyScopeCodes
      delete payload.supplyScopeNames

      return payload
    },

    formItems: [
      {
        type: 'fuzzy-select',
        prop: 'manufacturerCode',
        label: '厂商字典',
        labelProp: 'manufacturerName',
        api: '/sys/admin/config/dictItems',
        apiParams: { dictCode: 'mfr' },
        triggerFocus: true,
        required: true,
        disabled: isEdit
      },
      {
        type: 'select',
        prop: 'supplyScopeCodes',
        label: '供货范围',
        options: 'tdlDeviceType',
        collapseTags: false,
        multiple: true,
        required: true
      },
      { type: 'input', prop: 'contact', label: '联系人', maxlength: 10, trim: true },
      { type: 'input', prop: 'phone', label: '电话', maxlength: 20, trim: true },
      { type: 'textarea', prop: 'remark', label: '备注', maxlength: 200, showWordLimit: true, autoHeght: true }
    ]
  }
}
